"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
var theme = require("./theme.scss");
var icon_1 = require("@vidazoo/ui/lib/components/icon");
exports.default = (function (_a) {
    var className = _a.className, title = _a.title, message = _a.message, iconName = _a.iconName;
    return (React.createElement("div", { className: classnames(theme.message, className) },
        React.createElement("div", { className: theme.header },
            iconName ? React.createElement(icon_1.Icon, { className: theme.icon, iconName: iconName, size: 3.2 }) : null,
            title ? React.createElement("div", { className: theme.title }, title) : null),
        React.createElement("div", { className: theme.message }, message)));
});
